import dayjs from 'dayjs'

import { OrderType } from '@schemas'
import { downloadOrdersExcel, todayStamp } from '../order/orderExcel'
import { wholesaleStatusTitle } from './wholesaleOrder.format'

/** Wholesale Orders 목록 → 엑셀. 생성은 공용(order/orderExcel.ts) */
export const downloadWholesaleOrdersExcel = (orders: OrderType[]): Promise<void> =>
	downloadOrdersExcel({
		rows: orders.map(anOrder => ({
			id: anOrder.id,
			// UTC 문자열을 자르면 새벽 주문이 전날로 찍힌다 — 로컬 날짜로
			date: anOrder.createdAt ? dayjs(anOrder.createdAt).format('YYYY-MM-DD') : '',
			status: wholesaleStatusTitle(anOrder),
			amount: Number(anOrder.paidAmount ?? 0),
			currency: anOrder.currency,
		})),
		sheetName: 'Wholesale orders',
		fileName: `judahs-wholesale-orders-${todayStamp()}.xlsx`,
	})
